import React from "react";
import { mdiFileDocument } from "@mdi/js";
import Icon from "@mdi/react";
import { Itinerary } from "../../interfaces/itinerary.interface";

interface ItineraryDownloadLinksProps {
  itinerary: Itinerary;
}

const ItineraryDownloadLinks: React.FC<ItineraryDownloadLinksProps> = ({ itinerary }) => {
  if (!itinerary?.fileUrlCopy && !itinerary?.fileCNUrlCopy) {
    return null;
  }

  const enLink = itinerary?.fileUrlCopy ? (
    <a href={itinerary.fileUrlCopy} download>
      EN
    </a>
  ) : null;
  const cnLink = itinerary?.fileCNUrlCopy ? (
    <a href={itinerary.fileCNUrlCopy} download>
      CN
    </a>
  ) : null;
  const separator = enLink && cnLink ? " | " : "";

  return (
    <div className="item">
      <div className="icon">
        <Icon path={mdiFileDocument} size="20px" />
      </div>
      <label>
        Itinerary {enLink}
        {separator}
        {cnLink}
      </label>
    </div>
  );
};

export default ItineraryDownloadLinks;
